import axios from 'axios'
import { formatItems, TOTALS_REQUEST_TIMEOUT } from '../hooks/useRemoteOrderTotal'
import MutationApi from '../remote/mutationApi'
import StadiumRemote from '../remote/stadiumRemote'
import { formatOrderTotals } from '../utils/orderTotalUtils'

export const calculateSplitOrderTotal = async (cartItems, menuUuid, userUuid, taxExempt, useTaxClasses) => {
  try {
    const orderMenuItems = formatItems(cartItems, false)
    const cancelToken = axios.CancelToken.source()

    const configOverride = {
      cancelToken: cancelToken?.token ?? '',
      timeout: TOTALS_REQUEST_TIMEOUT,
      checkTokenExpiration: true,
    }

    const result = await StadiumRemote.getRemoteOrderTotal(
      orderMenuItems,
      menuUuid,
      undefined,
      configOverride,
      false,
      [],
      userUuid,
      taxExempt,
    )

    return formatOrderTotals(result.data, useTaxClasses, taxExempt)
  } catch (error) {
    //eslint-disable-next-line no-console
    console.log('error', error)
  }
}

export const createSplitOrder = async (
  lineItems,
  newOrderNumber,
  newOrderUuid,
  originalOrderUuid,
  payments,
  amount,
  userAttributes,
  userName,
) => {
  const result = await MutationApi.splitOrder({
    lineItemUuids: lineItems.map((item) => item.menuItemUuid),
    newOrderNumber,
    newOrderUuid,
    originalOrderUuid,
    payments,
    splittableAmount: amount, // should be the amount that comes from the split order total calc
    userAttributes,
    userName,
    isFractionalSplit: false,
  })

  if (result?.status !== 201) {
    throw new Error('Failed to create order')
  }

  const curMutation = result?.data?.orderMutations?.[0]
  if (!curMutation?.applied) {
    throw new Error(curMutation?.friendlyMessage || 'Failed split order')
  }

  return curMutation
}
